import React from "react";
import { timeSegmentGuides } from "@/data/trinity/trinityTimeSegmentGuides";
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon,  } from '@heroicons/react/24/outline' // 20 May 2025

import { nudgeIconMap } from "@/data/trinity/nudgeIconMap";

const EtTrinityTimeSegmentGuide = ({ guide, onNudgeClick }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Updated - 20 May 2025 - Grouped nudges by time segment for 'All' view
  // Updated - 24 May 2025 - Added nudgeIconMap

  if (!guide) return null;

  const isAllView = guide.label === "All";

  return (
    <div className="bg-white rounded shadow-sm m-1 p-1 animate-fade-in">
      {isAllView ? (
        <div className="grid grid-cols-2 justify-start items-start m-1 p-1 gap-2">
          {["early_morning", "morning", "mid_day", "evening", "night"].map((segmentKey) => {
            const segment = timeSegmentGuides[segmentKey];
            return (
              <div key={segmentKey} className="mb-4 h-full border border-gray-200 rounded-xl shadow-md">
                  <div className="flex justify-center w-full">       
                    <div className="flex flex-col justify-start items-start w-full h-full max-w-xl m-1 p-1">
                      <p className="text-lg font-semibold text-orange-600 mb-1">{segment.label}</p>
                      {segment.nudges.map((nudge, idx) => {
                        const IconComp = nudgeIconMap[nudge]; // 24 May 2025
                        return(
                          <div 
                            key={nudge} 
                            className="border-b w-full px-2 py-2 mb-3 cursor-pointer"
                            onClick={() => onNudgeClick?.(nudge)}
                            >
                            <div  
                              className="flex items-center opacity-0 animate-slide-in-left cursor-pointer"
                              style={{ animationDelay: `${idx * 200}ms`, animationFillMode: "forwards" }}
                            >
                              <p className="font-bold mx-2">{idx + 1}.</p>
                              <div 
                                className="h-10 w-10 flex justify-center items-center rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-lg shadow-black">
                                {IconComp && <IconComp className="h-8 w-8 text-white" />}
                              </div>
                            
                            <p className="text-xl text-gray-700 mx-2 px-2 hover:text-orange-700">{nudge}</p> 
                            </div>
                          </div>
                        )})}
                    </div>
                  </div>
              </div>
            );
          })}
        </div>
      ) : (
                  <div className="flex justify-center w-full mb-4">       
                    <div className="flex flex-col justify-start items-start w-full max-w-xl m-1 p-1">
                      
                      {guide.nudges?.map((nudge, idx) => {
                        const IconComp = nudgeIconMap[nudge]; // 24 May 2025
                        
                        return(
                        <div key={idx} className="border-b w-full px-2 py-2 my-2">
                          <div  
                            className="flex items-center opacity-0 animate-slide-in-left cursor-pointer"
                            style={{ animationDelay: `${idx * 200}ms`, animationFillMode: "forwards" }}
                            onClick={() => onNudgeClick?.(nudge)}
                          >
                            <p className="font-bold mx-1 px-1">{idx + 1}.</p>
                            <div 
                              className="h-10 w-10 flex justify-center items-center rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-lg shadow-black">
                              {IconComp && <IconComp className="h-8 w-8 text-white" />}
                            </div>
                            
                            <p className="text-xl text-gray-700 mx-1 px-1 hover:text-orange-700">{nudge}</p> 
                          </div>
                        </div>
                      )})}
                    </div>
                  </div>
      )}
    </div>
  );
};

export default EtTrinityTimeSegmentGuide;